module.exports = {"id":"dp2_4l3q3","text":"Collaborating through Digital Technologies","instructions":"Which situation best demonstrates ethical and responsible use of AI in collaboration?","multiselect":false,"questionType":"PickOne","random":true,"options":[{"id":"dp2_4l3q3-a1","text":"Using AI suggestions with review","score":3.7},{"id":"dp2_4l3q3-a2","text":"Letting AI decide all tasks","score":1.3},{"id":"dp2_4l3q3-a3","text":"Ignoring AI system outputs","score":1.3}],"groupTitle":"Digital Profiler Knowledge Matrix","category":"2.4"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.4/l3q3.json
// module id = 1052
// module chunks = 41